import styled from 'styled-components';

export const StyledButton = styled.button`
  background-color: ${(props) => props.theme.colors.yellow300};
  border-color: ${(props) => props.theme.colors.yellow300};
  color: ${(props) => props.theme.colors.blue600};
  font-size: 1em;
  font-weight: bold;
  height: 48px;
  padding: 0.5em;
  text-transform: unset;

  :active,
  :focus {
    background-color: ${(props) => props.theme.colors.yellow500};
    border-color: ${(props) => props.theme.colors.yellow500};
  }
`;

export const StyledClose = styled.div`
  cursor: pointer;
  font-size: 1.25em;
  margin: 0.5em;
  position: absolute;
  right: 0;
  top: 0;
  transform: rotate(45deg);
`;
